module.exports = __webpack_public_path__ + "static/media/56.490a4a68.png";